module.exports = __webpack_public_path__ + "static/media/rlo1.059b5146.svg";